'use strict';

module.exports = {
  ERRORS: {
    LOGIN: {
      INVALID_CREDENTIALS:
        'Correo electrónico o contraseña incorrecta. Por favor, vuelve a intentarlo nuevamente.',
      PASSWORD_LOCKED_ERROR:
        'Has superado el límite de intentos para ingresar tu contraseña. Ya te hemos enviado un código verificador revisa tu correo electrónico e ingrésalo.',
      PASSWORD_REMAINS_LOCKED_ERROR:
        'Has superado el límite de intentos para ingresar tu contraseña. Ya te hemos enviado un código verificador revisa tu correo electrónico e ingrésalo.',
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    OTP_LOGIN: {
      OTP_VALIDATION_ERROR:
        'Código verificador incorrecto. Por favor, vuelve a intentarlo nuevamente.',
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    SOFT_LOGIN: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    USER_STATUS: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    RESET_PASSWORD: {
      INVALID_CURRENT_PASSWORD_ERROR: 'Contraseña actual inválida',
      PASSWORD_LOCKED_ERROR:
        'Has superado el límite de intentos para ingresar tu contraseña. Ya te hemos enviado un código verificador revisa tu correo electrónico e ingrésalo.',
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    LEGAL_TEXT: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    CONSENT_TEMPLATE: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    SAVE_CONSENT: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    OTP_BY_EMAIL: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    OTP_VALIDATION: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    UPDATE_USER: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
    GET_USER: {
      DEFAULT:
        '¡Lo sentimos! Ha ocurrido un error inesperado. Por favor, vuelve a intentarlo nuevamente.',
    },
  },
};
